import {Record} from 'immutable';

const Recipient = Record({
    id: String(),
    title: String(),
    image: String(''),
    subtitle: String(''),
    isDefault: false,
    canOverrideOrgPostBlock: false,
});

const fromAPI = data => {
    return new Recipient({
        id: data.id,
        isDefault: data.isDefault,
        canOverrideOrgPostBlock: data.canOverrideOrgPostBlock ?? false,
        title: data.title || data.name,
        subtitle: data.subtitle || data.group,
        image: data.image,
    });
};

export default {
    record: Recipient,
    fromAPI,
};
